import { configureStore } from '@reduxjs/toolkit'
import { baglimitSlice, boxDashboardWebReturnCountsSlice, boxDashboardWebReturnInventoryProcessWiseSlice, boxDashboardWebReturnInventorySlice, cardSlice, claimChatMessageSlice, claimCloseTicketSlice, claimCounterMatricSlice, claimCreateSlice, claimEmailTemplateCreateSlice, claimEmailTemplateDropdownSlice, claimEmailTemplateEditSlice, claimEmailTemplateReadSlice, claimEmailTemplateUpdateSlice, claimExportSlice, claimListingSlice, claimMediaSlice, claimReasonCreateSlice, claimReasonDeleteSlice, claimReasonReadSlice, claimRemarkSlice, claimStatusChangeSlice, claimStatusDropdownSlice, closeBagDropdownSlice, closeBagUpdateSlice, closeStatusUpdateSlice, counterMetricsSlice, courierOptionSlice, courierReturnEmailSettingCreateSlice, courierReturnEmailSettingReadSlice, forwardBackwardSlice, gateEntryPassOptionSlice, gatekeeperNameOptionSlice, graphClaimAcceptAmountSlice, graphClaimAcceptSlice, graphLostAmountScanDelaySlice, graphPortalWiseSlice, graphPortalwiseAmountSlice, loaderSlice, looseReturnBagsExportSlice, looseReturnBagsStoreAllSlice, looseReturnExportSlice, looseReturnPackagesExportSlice, looseReturnPackagesListSlice, looseReturnPackagesSlice, measurementUnitReadSlice, mrpCreationCreateBatchBundleSlice, mrpCreationCreateSlice, mrpCreationDropdownsSlice, mrpCreationUpdateLogSlice, notRespondingByPortalSlice, notRespondingByUsSlice, ontimeSecondaryPacageSlice, orderDetailsBySerialCodeSlice, orderItemCreateSlice, orderItemReadSlice, orderReturnBoxCreateSlice, orderReturnCreateSlice, orderReturnDetailsSlice, orderReturnDropdownSlice, orderReturnExportSlice, orderReturnReadSlice, partyOptionSlice, podCounterSlice, primaryScanBagListSlice, primaryScanFormSlice, primaryScanListSlice, repackingCreateSlice, repackingDropdownsSlice, repackingExportSlice, repackingReadSlice, returnContainerBoxSummarySlice, returnContainerExportSlice, returnContainerReadSlice, returnInventoryProcessWiseSlice, returnInventorySlice, returnedContainerBoxCreateSlice, returnedContainerBoxDeletePicturesDocumentsSlice, returnedContainerBoxReadSlice, returnedContainerBoxSummaryBbscDetailExportSlice, returnedContainerBoxSummaryBbscDetailSlice, returnedContainerBoxSummaryDropdownSlice, returnedContainerBoxSummaryExportSlice, returnedContainerBoxSummaryItemDetailExportSlice, returnedContainerBoxSummaryItemDetailSlice, returnedContainerBoxSummaryPicturesSlice, returnedContainerBoxUpdateSlice, returnedContainerCreateSlice, returnedContainerDropdownsSlice, returnedContainerUpdateSlice, secondaryCounterMatricSlice, sendClaimMessageSlice, serialCodebyOrderNoSlice, setClaimRemarkSlice, setbaglimitSlice, suffixstringsSlice, suffixstringsStoreAllSlice, tatSettingsSlice, tatSettingsStoreAllSlice, ticketCloseDropdownSlice, tokenNumberOptionSlice, tserialCodesTrackingNoSlice, turnAroundTimePortalWiseSlice, turnAroundTimeWiseSlice, uploadCountSlice,} from '../store/user/userSlice'

export const store = configureStore({
  reducer: {
    loader:loaderSlice,
    dashboardCard: cardSlice,
    //setting-api
    baglimit:baglimitSlice,
    setbaglimit:setbaglimitSlice,
    courierReturnEmailSettingCreate:courierReturnEmailSettingCreateSlice,
    courierReturnEmailSettingRead:courierReturnEmailSettingReadSlice,
    suffixstrings:suffixstringsSlice,
    suffixstringsStoreAll:suffixstringsStoreAllSlice,
    tatSettingsStoreAll:tatSettingsStoreAllSlice,
    tatSettings:tatSettingsSlice,
    //end
    primaryScanList:primaryScanListSlice,
    primaryScanBagList:primaryScanBagListSlice,
    courierOption:courierOptionSlice,
    primaryScanForm:primaryScanFormSlice,
    closeStatusUpdate:closeStatusUpdateSlice,
    looseReturnBagsStoreAll:looseReturnBagsStoreAllSlice,
    looseReturnPackages:looseReturnPackagesSlice,
    looseReturnPackagesList:looseReturnPackagesListSlice,
    gatekeeperNameOption:gatekeeperNameOptionSlice,
    tokenNumberOption:tokenNumberOptionSlice,
    gateEntryPassOption:gateEntryPassOptionSlice,
    partyOption:partyOptionSlice,
    looseReturnExport:looseReturnExportSlice,
    looseReturnPackagesExport:looseReturnPackagesExportSlice,
    looseReturnBagsExport:looseReturnBagsExportSlice,
    uploadCount:uploadCountSlice,
    closeBagDropdown:closeBagDropdownSlice,
    //primary-scan-box
    returnedContainerDropdowns:returnedContainerDropdownsSlice,
    returnContainerRead:returnContainerReadSlice,
    returnedContainerCreate:returnedContainerCreateSlice,
    returnedContainerUpdate:returnedContainerUpdateSlice,
    returnedContainerBoxUpdate:returnedContainerBoxUpdateSlice,
    returnedContainerBoxRead:returnedContainerBoxReadSlice,
    returnedContainerBoxCreate:returnedContainerBoxCreateSlice,
    //repecking
    repackingCreate:repackingCreateSlice,
    repackingExport:repackingExportSlice,
    repackingRead:repackingReadSlice,
    repackingDropdowns:repackingDropdownsSlice,
    //mrp
    mrpCreationDropdowns:mrpCreationDropdownsSlice,
    mrpCreationUpdateLog:mrpCreationUpdateLogSlice,
    mrpCreationCreate:mrpCreationCreateSlice,
    mrpCreationCreateBatchBundle:mrpCreationCreateBatchBundleSlice,
    //secondary-scan
    orderReturnRead:orderReturnReadSlice,
    orderReturnDropdown:orderReturnDropdownSlice,
    orderReturnDetails:orderReturnDetailsSlice,
    orderReturnCreate:orderReturnCreateSlice,
    orderReturnBoxCreate:orderReturnBoxCreateSlice,
    orderReturnExport:orderReturnExportSlice,
    orderItemRead:orderItemReadSlice,
    orderItemCreate:orderItemCreateSlice,
    measurementUnitRead:measurementUnitReadSlice,
    serialCodebyOrderNo:serialCodebyOrderNoSlice,
    orderDetailsBySerialCode:orderDetailsBySerialCodeSlice,
    tserialCodesTrackingNo:tserialCodesTrackingNoSlice,
    ontimeSecondaryPacage:ontimeSecondaryPacageSlice,
    returnInventory:returnInventorySlice,
    returnInventoryProcessWise:returnInventoryProcessWiseSlice,
    //Returned Container Box Summary kamlesh ji
    returnContainerBoxSummary:returnContainerBoxSummarySlice,
    returnedContainerBoxSummaryPictures:returnedContainerBoxSummaryPicturesSlice,
    returnedContainerBoxSummaryExport:returnedContainerBoxSummaryExportSlice,
    returnedContainerBoxSummaryBbscDetail:returnedContainerBoxSummaryBbscDetailSlice,
    returnedContainerBoxSummaryBbscDetailExport:returnedContainerBoxSummaryBbscDetailExportSlice,
    returnedContainerBoxSummaryItemDetail:returnedContainerBoxSummaryItemDetailSlice,
    returnedContainerBoxSummaryItemDetailExport:returnedContainerBoxSummaryItemDetailExportSlice,
    forwardBackward:forwardBackwardSlice,
    //Forward and Backward Import
    claimReasonCreate:claimReasonCreateSlice,
    claimReasonDelete:claimReasonDeleteSlice,
    claimReasonRead:claimReasonReadSlice,
    //claim
    counterMetrics:counterMetricsSlice,
    claimListing:claimListingSlice,
    claimExport:claimExportSlice,
    sendClaimMessage:sendClaimMessageSlice,
    claimChatMessage:claimChatMessageSlice,
    claimCloseTicket:claimCloseTicketSlice,
    claimRemark:claimRemarkSlice,
    setClaimRemark:setClaimRemarkSlice,
    claimMedia:claimMediaSlice,
    claimStatusChange:claimStatusChangeSlice,
    ticketCloseDropdown:ticketCloseDropdownSlice,
    claimStatusDropdown:claimStatusDropdownSlice,
    //dashbord-slice
    podCounter:podCounterSlice,
    secondaryCounterMatric:secondaryCounterMatricSlice,
    claimCounterMatric:claimCounterMatricSlice,
    graphPortalWise:graphPortalWiseSlice,
    graphClaimAccept:graphClaimAcceptSlice,
    graphPortalwiseAmount:graphPortalwiseAmountSlice,
    graphClaimAcceptAmount:graphClaimAcceptAmountSlice,
    graphLostAmountScanDelay:graphLostAmountScanDelaySlice,
    notRespondingByUs:notRespondingByUsSlice,
    notRespondingByPortal:notRespondingByPortalSlice,
    closeBagUpdate:closeBagUpdateSlice,
    turnAroundTimePortalWise:turnAroundTimePortalWiseSlice,
    turnAroundTimeWise:turnAroundTimeWiseSlice,
    //box Dashboard
    boxDashboardWebReturnCounts:boxDashboardWebReturnCountsSlice,
    boxDashboardWebReturnInventory:boxDashboardWebReturnInventorySlice,
    boxDashboardWebReturnInventoryProcessWise:boxDashboardWebReturnInventoryProcessWiseSlice,
    returnedContainerBoxSummaryDropdown:returnedContainerBoxSummaryDropdownSlice,
    returnedContainerBoxDeletePicturesDocuments:returnedContainerBoxDeletePicturesDocumentsSlice,
  //claim-email
  claimEmailTemplateDropdown:claimEmailTemplateDropdownSlice,
  claimEmailTemplateCreate:claimEmailTemplateCreateSlice,
  claimEmailTemplateRead:claimEmailTemplateReadSlice,
  claimEmailTemplateEdit:claimEmailTemplateEditSlice,
  claimEmailTemplateUpdate:claimEmailTemplateUpdateSlice,
  claimCreate:claimCreateSlice,
  returnContainerExport:returnContainerExportSlice,
  }
})